<template>
  <div :class="['editors-staff-skeleton', { _mobile: isMobile }]">
    <div class="editors-staff-skeleton__content">
      <div class="editors-staff-skeleton__breadcrumbs">
        <BreadcrumbsSkeleton />
      </div>
      <div class="editors-staff-skeleton__header">
        <HeaderSkeleton />
      </div>
      <div class="editors-staff-skeleton__chief-editor">
        <ChiefEditorSkeleton />
      </div>
      <div class="editors-staff-skeleton__authors-experts">
        <AuthorsExpertsSkeleton />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import BreadcrumbsSkeleton from './BreadcrumbsSkeleton.vue';
import HeaderSkeleton from './HeaderSkeleton.vue';
import ChiefEditorSkeleton from './ChiefEditorSkeleton.vue';
import AuthorsExpertsSkeleton from './AuthorsExpertsSkeleton.vue';

const isMobile: boolean = useIsMobile();
</script>

<style lang="less">
.editors-staff-skeleton {
  &__content {
    .flex-column(@size-x10);

    max-width: 880px;
  }

  &__breadcrumbs {
    margin-top: @size-x10;
  }
}
</style>
